import banner from '../vow-header-banner.jpg';
let cached=null;
/** Header banner as a base64 data URI so the saved HTML is self-contained for the backend. */
export function getBannerDataUri() {
  if(!cached) {
    cached=fetch(banner)
      .then(r=>{if(!r.ok)throw new Error('Could not load the header banner image.');return r.blob();})
      .then(blob=>new Promise((resolve,reject)=>{const fr=new FileReader();fr.onload=()=>resolve(String(fr.result));fr.onerror=()=>reject(fr.error);fr.readAsDataURL(blob);}))
      .then(uri=>uri.replace(/^data:[^;,]*;/,'data:image/jpeg;'))
      .catch(e=>{cached=null;throw e;});
  }
  return cached;
}
